// Widget scripts
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetSEO from './js/widgets/cardWidgetSEO.js';
import cardWidgetAds from './js/widgets/cardWidgetAds.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cardWidgetFeatured from './js/widgets/cardWidgetFeatured.js';
import cardWidgetVideos from './js/widgets/cardWidgetVideos.js';
import { facebookfeed } from './js/widgets/socialNetworkWidget.js';
import cardWidgetCardGrid from './js/widgets/cardWidgetCardGrid.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import AOS from 'aos';
import 'aos/dist/aos.css';
// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();   
    cardWidgetSEO();
    cardWidgetAds();
    multiScheduleFeature();    
    cardWidgetFeatured();
    cardWidgetVideos();
    facebookfeed(true);
    cardWidgetCardGrid();
    cssSponsors();

    AOS.init();
  });
}


